@use '@/sass/variables';

.taskStatusDropdown {
  background-image: none !important;
  background-color: whitesmoke;
  color: variables.$dark-blue;
  border: 0 !important;
  box-shadow: none;
  &:focus {
    background-color: lightgrey;
    box-shadow: none !important;
  }
}

.taskCard {
  .executionContainer {
    position: relative;
    width: 24px;
    height: 24px;

    .iconContainer,
    .checkboxContainer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity 0.5s ease-in-out;
    }

    .iconContainer {
      opacity: 1;
      z-index: 2;
    }

    .checkboxContainer {
      opacity: 0;
      z-index: 1;
    }
  }
}

.taskCard.selectedForExecution {
  border-color: variables.$blue;
  border-width: 2px;
}

.taskCard:not(.executionDisabled):hover,
.taskCard:not(.executionDisabled).selectedForExecution {
  .checkboxContainer {
    opacity: 1;
    z-index: 2;
  }

  .iconContainer {
    opacity: 0;
    z-index: 1;
  }
}

.itemSkeletonContainer {
  .taskSkeleton {
    height: 190px;
    width: 650px;

    .loading {
      display: inline-block;
      height: 100%;
      width: 100%;
      position: relative;
      overflow: hidden;
      background-color: #dddbdd;

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        transform: translateX(-100%);
        background-image: linear-gradient(
          90deg,
          rgba(#fff, 0) 0,
          rgba(#fff, 0.2) 20%,
          rgba(#fff, 0.5) 60%,
          rgba(#fff, 0)
        );
        animation: loadingAnimation 1s infinite;
        content: '';
      }
    }
  }
}

@keyframes loadingAnimation {
  100% {
    transform: translateX(100%);
  }
}
